/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import 'moment/locale/pt';
import { useNavigate } from 'react-router-dom';

import { Box, CircularProgress, Typography, Button } from '@mui/material';
import CustomizedTables from '../../../../components/Table';
import PaginationRounded from '../../../../components/NewPagination';
import FixedContainer from '../../../../components/Container';
import { GetFetch } from '../../../../services/apiBase';
import { useAppStatus } from '../../../../hooks/app';
import axios from 'axios';

const HitóricoB3 = ({ history }) => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [cprs, setCprs] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalPages, setTotalPages] = useState(0);

  const navigate = useNavigate()
  const { getCprSummarization } = useAppStatus();

  const COLUMNSTABLE = [
    {
      headerName: 'Número da CPR',
      type: 'default',
      value: {
        first: {
          value: 'cpr_number'
        }
      }
    },
    {
      headerName: 'Tipo da CPR',
      type: 'default',
      value: {
        first: {
          value: 'type'
        }
      }
    },
    {
      headerName: 'Nome do investidor',
      type: 'default',
      value: {
        first: {
          parent: ['shared_personne'],
          value: 'name'
        }
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Data da assinatura',
      type: 'date',
      value: {
        first: {
          value: 'date_start'
        }
      }
    },
    {
      headerName: 'Valor investido',
      type: 'money',
      value: {
        first: {
          value: 'amount_cpr'
        }
      }
    },
    {
      headerName: 'Status',
      type: 'default',
      value: {
        first: {
          parent: ['b3_cpr'],
          value: 'b3_status'
        }
      },
      noData: 'Não informado'
    },
  ]

  const getCPR = useCallback(async () => {
    setLoading(true)
    try {
      const response = await GetFetch(`/financial/b3/listCompleted?page=${currentPage}&limit=${limit}`);
      setLimit(response.data.perPage);
      setTotalPages(response.data.lastPage);
      setCprs(response.data.data);
      let arrayAux = response.data.data.filter((cpr) => cpr?.b3_cpr?.b3_status !== 'REGISTERED' && cpr?.b3_cpr?.b3_status !== 'LIQUIDATED');
      setError(false)

    } catch (error) {
      console.log(error)
      setError(true)
    } finally {
      setLoading(false)
    }
  }, [currentPage]);


  const handleOpenDetails = (cpr) => {
    cpr.flowType = []
    return navigate('/cprf/details', { state: { cpr: cpr } })
  }

  const handleOpenRegister = (cprId, personneId, cpr) => {
    return navigate('/cprf/registro_B3', { state: { cprId: cprId, personneId: personneId, cpr: cpr } })
  }

  const loadingComponent = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          paddingTop: 2
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar as CPRF's
        </Typography>
      </Box>
    )
  }

  const registerButtonComponent = (cpr) => {
    let registered = null;
    try { registered = JSON.parse(cpr.b3_cpr.b3_response); } catch {}
    return (
      <>
        {cpr.b3_cpr.b3_status === 'PENDING' ?
          <Button variant="contained" color="success" sx={{ marginRight: 1 }} onClick={() => handleOpenRegister(cpr.id, cpr.personne_id, cpr)}>Registrar CPR</Button>
          : cpr.b3_cpr.b3_status === 'ERROR-API' ? `Erro: ${registered?.error}` : cpr.b3_cpr.b3_id
        }
      </>
    )
  }

  const tableComponent = () => {
    return (
      <Box>
        <CustomizedTables
          data={cprs}
          columns={COLUMNSTABLE}
          options
          action={handleOpenDetails}
          moreOptionsTitle={'CódigoB3 / Ação'}
          moreOptions={registerButtonComponent}
        />
        <Box sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          paddingTop: 2
        }}>
          <PaginationRounded count={totalPages} page={currentPage} handleChange={setCurrentPage} />
        </Box>
      </Box>
    )
  }

  useEffect(() => {
    getCPR();
  }, [getCPR]);

  useEffect(() => {
    getCprSummarization();
  }, []);

  return (
    <FixedContainer>
      <Box sx={{
        width: '100%',
        height: '100%',
        backgroundColor: '#F9FBFD',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        boxShadow: 3,
        borderRadius: '10px',
        padding: 2,
      }}>
        {loading ? loadingComponent() :
          error ? errorMessage() :
            cprs && cprs.length > 0 ?
              <>
                <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
                  Histórico de CPRF's B3
                </Typography>

                {tableComponent()}
              </>
              :
              <Box sx={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center'
              }}>
                <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
                  No momento não existem CPRF's para serem mostradas aqui
                </Typography>
              </Box>
        }
      </Box>
    </FixedContainer>
  );
}
export default HitóricoB3;
